export const PREFS_DISABLE_MANUAL_NOTIFICATION_PROMPT_KEY =
  "prefs:disable_manual_notify_prompt";
